export default __webpack_public_path__ + "static/media/dsstest15.7541ce22.jpg";